<ct-search-filters
  #searchFilter
  [configuration]="filtersConfiguration"
  (filter)="filter($event)"
></ct-search-filters>

<mat-card>
  <mat-card-content>

    <mat-card-actions align="end">
      <button mat-raised-button color="primary" (click)="create()">Nuova Rubrica</button>
    </mat-card-actions>

    <ct-datatable
      *ngIf="addressBook"
      [configuration]="addressBook"
      (reload)="fetch($event)"
      (onEdit)="edit($event)"
      (onDelete)="delete($event)"
      (onDetail)="detail($event)"
    ></ct-datatable>
  </mat-card-content>
</mat-card>



<ng-template #typeCellTemplate let-row="row" let-value="value" let-i="index">

   <p> {{ getTypeLabel(value) }}</p>

</ng-template>

<ng-template #detailAddressBookButton let-value="value">

  <button
    mat-icon-button
    color="primary"
    (click)="detail(value)">
    <mat-icon>contacts</mat-icon>
  </button>

</ng-template>